<template>
  <div v-loading="loading" class="radius6 hline">
    <!-- 报名基本信息-->
    <signup-info ref="auditHeader" :staus="staus" :projectInfo="projectInfo" :statisticsInfo="statisticsInfo"></signup-info>
    <div class="h12 w100p bc-cCF6F7FA"></div>
    <div class="bg-white ph24 pv24">
      <div class="btn_common_display">
        <div class="btn_common_display_item mb16">
           <!--报名设置-->
            <yxt-button type="primary" size="large" @click="setApply" :disabled="!factor || (!isOperated && projectInfo.projectStatus===4)">{{language().btn_settings}}</yxt-button>
            <!--添加名额-->
            <yxt-button plain size="large" :disabled="!factor || (!isOperated && projectInfo.projectStatus===4)" @click="showDialog">{{language().btn_add}}</yxt-button>
            <!--报名表单-->
            <yxt-button plain size="large" v-if="formDatasLen" @click="showFormList">{{language().btn_enrollform}}</yxt-button>
            <!--批量转正-->
            <yxt-button v-if="projectInfo.formalQuota !== 0" plain size="large" :disabled="!factor || (!isOperated && projectInfo.projectStatus===4)" @click="batchPositive">{{language().btn_batchpositive}}</yxt-button>
            <yxt-dropdown custom-elm class="ml12" @command="handleMoreOpt">
              <yxt-button plain size="large">
                {{language().btn_more_operation}}
                <i class="yxt-icon-arrow-down yxt-icon--right"></i>
              </yxt-button>
              <yxt-dropdown-menu slot="dropdown">
                <!-- 催促报名 -->
                <yxt-dropdown-item :disabled="!factor || (!isOperated && projectInfo.projectStatus===4)" command="1">{{language().btn_urgeSignupaudit}}（{{ projectInfo.maxPushTimes -(projectInfo.remainPushTimes || 0)}}/{{ projectInfo.maxPushTimes || 0 }}）</yxt-dropdown-item>
                <!-- 导出数据 -->
                <yxt-dropdown-item command="4">{{language().btn_export_data}}</yxt-dropdown-item>
              </yxt-dropdown-menu>
            </yxt-dropdown>
        </div>
        <div class="btn_common_display_item mb16">
          <yxt-select
            v-model="query.enrollType"
            class="mr12 w144 h40 lh40"
            clearable
            :placeholder="language().lbl_registration_method"
            @change="handleSearch"
          >
            <yxt-option v-for="(value, key, index) in enrollWays" :key="index" :label="value.label" :value="key" />
          </yxt-select>
          <yxt-select
            v-model="query.enrollStatus"
            class="mr12 w144 h40 lh40"
            clearable
            :placeholder="language().lbl_status"
            @change="handleSearch"
          >
            <yxt-option
              v-for="item in statusMap"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </yxt-option>
          </yxt-select>
          <yxt-input
            v-model="query.searchKey"
            :placeholder="language().lbl_name_search"
            searchable
            maxlength="50"
            style="width: 240px;"
            @search="handleSearch"
            @keyup.enter.native="handleSearch"
          ></yxt-input>
        </div>
      </div>

      <yxt-table
        ref="table"
        v-loading="loading"
        row-key="id"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <yxt-table-column
          type="selection"
          :selectable="selectable"
          class-name="yxt-o2o-selection-col"
          :reserve-selection="true"
          width="38"
          align="right"
          fixed="left"
          clear-padding="left-right"
        >
        </yxt-table-column>
        <yxt-table-column
          prop="fullname"
          :label="language().lbl_name"
          fixed="left"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <yxtbiz-user-name :name="scope.row.fullname" />
            <span v-if="scope.row.username">
            （<yxtbiz-user-name :name="scope.row.username" />）
            </span>
          </template>
        </yxt-table-column>
        <yxt-table-column v-for="(item,index) in columns" :label="item" :key="item+index" min-width="250" show-overflow-tooltip>
          <template slot-scope="scope">
            {{item | getColumn(scope.row.clientInfo)}}
          </template>
        </yxt-table-column>
        <!-- 部门 -->
        <yxt-table-column
          prop="deptName"
          :label="language().lbl_department"
          min-width="200"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <yxtbiz-dept-name :name="scope.row.deptName || '--'" />
          </template>
        </yxt-table-column>
        <!-- 岗位 -->
        <yxt-table-column
          prop="positionNameList"
          :label="language().lbl_position_name"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span><yxtbiz-position-name :name="scope.row.positionNameList || '--'" /></span>
          </template>
        </yxt-table-column>
        <yxt-table-column
          prop="enrollType"
          :label="language().lbl_registration_method"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ enrollWays[scope.row.enrollType].label || '--' }}</span>
          </template>
        </yxt-table-column>
        <yxt-table-column prop="mobile" :label="language().lbl_phone" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile || '--' }}</span>
          </template>
        </yxt-table-column>
        <yxt-table-column :label="language().lbl_sign_up_time" width="166">
          <template slot-scope="scope">
            {{ scope.row.createTime | date('yyyy-MM-dd HH:mm', '--') }}
          </template>
        </yxt-table-column>
        <yxt-table-column :label="language().lbl_status" :min-width="120">
          <template slot-scope="scope">
            {{ statusMap[scope.row.enrollStatus].label || '--' }}
          </template>
        </yxt-table-column>
        <yxt-table-column
          prop="checkOpinion"
          :label="language().lbl_remark"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.checkOpinion || '--' }}</span>
          </template>
        </yxt-table-column>
        <yxt-table-column
          :label="language().lbl_operation"
          min-width="228"
          fixed="right"
          align="left"
        >
          <template slot-scope="scope">
            <yxt-button type="text" @click.stop="viewDetail(scope.row)">{{language().btn_details}}</yxt-button>
            <yxt-button v-if="scope.row.enrollStatus === 1 || scope.row.enrollStatus === 5" type="text" :disabled="!factor || (!isOperated && projectInfo.projectStatus===4)" @click="cancelStatus(scope.row)">{{language().btn_disqualification}}</yxt-button>
          </template>
        </yxt-table-column>
      </yxt-table>
      <yxt-row class="mt16" type="flex" justify="end">
        <yxt-pagination :current-page="query.page"
                        :page-size="query.limit"
                        :total="count"
                        layout="total, prev, pager, next, sizes, jumper"
                        simple-total
                        show-on-single-page
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange">
        </yxt-pagination>
      </yxt-row>
    </div>
    <yxt-drawer
      ref="selectDrawer"
      :header-border="false"
      :destroy-on-close="true"
      size="960px"
      :visible.sync="dialogVisible"
      :before-close="closeSelect"
    >
      <yxt-user-selector
        ref="selector"
        :limit="limit"
        :data="users"
        :tabs="tabs"
        @change="change"
        :function-code="functionCode"
        :data-permission-code="dataPermissionCode"
        :isShowDeptment="false"
        :enableGroupCorp="enableGroupCorp"
        :targetOrgId="targetOrgId"
        :disabledOrgSelect="disabledOrgSelect"
        :isOrgSelectAlone="isOrgSelectAlone"
      >
      </yxt-user-selector>
      <div slot="footer">
        <yxt-button @click="closeDialog" plain>{{language().btn_cancel}}</yxt-button>
        <yxt-button type="primary" @click="addUsers">{{language().btn_confirm}}</yxt-button>
      </div>
    </yxt-drawer>
    <yxt-drawer
      :visible.sync="formsVisible"
      :title="language().tit_registration_form"
      size="960px"
      :before-close="beforeClose"
      :destroy-on-close="true"
    >
      <div class="yxtbiz-signup" style="height: 100%;">
        <div class="absolute left0 right0 top0 bottom0">
          <div class="h64">
            <yxt-input class="w260" :placeholder="language().lbl_name_search" v-model="keyword" clearable @search='surveys()' @clear="surveys()" searchable />
          </div>
          <div ref="formTable" class="absolute top64 bottom0 left0 right0">
            <yxt-table
              :data="formDatas"
              virtual
              :rowHeight='40'
              row-class-name="pointer"
              :max-height="`${formHeight}px`"
              @row-click="rowClick"
              @sort-change="sortChange">
              <yxt-table-column :label="language().lbl_vname">
                <template slot-scope="scope">
                  <span class="c-cC436BFF">{{scope.row.name}}</span>
                </template>
              </yxt-table-column>
              <yxt-table-column
                width="200px"
                prop="createTime"
                sortable
                :label="language().lbl_adding_time">
              </yxt-table-column>
            </yxt-table>
          </div>
        </div>
      </div>
      <div slot="footer">
        <yxt-button @click="beforeClose" plain>{{language().btn_cancel}}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
import SignupInfo from '../../components/manage/info.vue';
import SelectPartOrAll from '../../components/selectPartOrAll.vue';

export default {
  name: 'YxtbizSignupManage',
  inject: ['language'],
  components: {
    SignupInfo,
    SelectPartOrAll
  },
  filters: {
    date(val) {
      return val;
    },
    getColumn(column, clientInfo) {
      let info = JSON.parse(clientInfo);
      let arr = [];
      if (info.length > 0) {
        info.forEach(item => {
          if (item.label === column) {
            arr.push(item.value);
          }
        });
      }
      return arr.toString();
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    // 取消资格结果说明（业务可补充文案）
    cancelMessage: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    },
    // 是否展示集团化选择器
    enableGroupCorp: {
      type: Boolean,
      default: false
    },
    // 集团版指定机构Id
    targetOrgId: {
      type: String,
      default: ''
    },
    // 集团版机构选择组件是否禁用
    disabledOrgSelect: {
      type: Boolean,
      default: false
    },
    // 集团版选人组件各平台是否独立选择
    isOrgSelectAlone: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      staus: {},
      projectInfo: {},
      statisticsInfo: {},
      // 报名状态 0：待审核，1：审核通过(正式名额)，2：审核不通过，3:放弃资格，4：取消资格 5：替补名额
      statusMap: [...this.$parent.auditStatus.map(_ => ({
        ..._,
        label: _.info ? `${_.label}（${_.info}）` : _.label
      }))],
      // 报名方式,0：自主报名，1：后台指派 ,2：代报名
      enrollWays: {...this.$parent.enrollTypeObj},
      value: '',
      totalCount: 0,
      tableData: [],
      dialogVisible: false, // 添加名额弹窗
      limit: 50, // 添加名额 限制多少人
      tabs: ['persons', 'advance'],
      users: [], // 添加名额list
      tempUsers: [],
      query: {
        projectId: null,
        enrollStatus: null,
        enrollType: null,
        searchKey: null,
        current: 1,
        limit: 20
      },
      pages: 0,
      count: 0,
      multipleSelection: [], // 复选框选中的人
      loading: false,
      qrCodeUrl: '', // 二维码链接
      showOverTime: false, // 已过期
      selectType: 1,
      excludeIdList: [],
      tableDataMap: new Map(),
      // 报名表单
      formsVisible: false,
      formDatasLen: 0,
      formDatas: [],
      formHeight: 400,
      createTimeDirection: '',
      keyword: '',
      factor: 0

    };
  },
  async created() {
    // 注册项目
    const SDK = this.$parent.SDK;
    this.siginup = new SDK(this.id);
    this.staus = SDK.getCodes('pc').staus;
    this.$parent.fmessage(await this.siginup.factorCheck(), ({result}) => {
      this.factor = result;
    });
    this.surveys(true);
    this.getProjectInfo();
    this.getStatisticsInfo();
    this.getList();
  },
  computed: {
    isOperated() {
      // 报名管理-报名设置、添加学员、批量转正、更多操作、列表中的取消资格按钮
      // 不可以操作置灰
      // operationOpen  ：报名结束后，是否开启操作拦截 0否，1是
      return !!((this.projectInfo.hasOwnProperty('operationOpen') && this.projectInfo.operationOpen === 0));
    },
    auth() {
      return {
        enroll: {
          setting:
            this.checkPrincipal ||
            this.$checkActionPermission(
              this.$route.meta.functionCode,
              'activities_set_info'
            ), // 报名设置
          getData:
            this.checkPrincipal ||
            this.$checkActionPermission(
              this.$route.meta.functionCode,
              'activities_approval_get'
            ), // 获取报名审核数据
          check:
            this.checkPrincipal ||
            this.$checkActionPermission(
              this.$route.meta.functionCode,
              'activities_approval'
            ), // 报名审核
          form:
            this.checkPrincipal ||
            this.$checkActionPermission(
              this.$route.meta.functionCode,
              'activities_approval_form'
            ), // 报名表单
          batchFormal:
            this.checkPrincipal ||
            this.$checkActionPermission(
              this.$route.meta.functionCode,
              'activities_approval_change_formal'
            ), // 批量转正
          batchCheck:
            this.checkPrincipal ||
            this.$checkActionPermission(
              this.$route.meta.functionCode,
              'activities_batch_approval'
            ), // 批量审核
          export:
            this.checkPrincipal ||
            this.$checkActionPermission(
              this.$route.meta.functionCode,
              'activities_activitiesExport'
            ) // 导出列表
        }
      };
    }
  },
  watch: {
    multipleSelection() {
      this.multiple();
    }
  },
  methods: {
    multiple() {
      if (this.multipleSelection.length > 50) {
        this.$message.warning(this.language().msg_50_upper_limit);
      }
    },
    // 获取基本信息
    async getProjectInfo() {
      const SDK = this.$parent.SDK;
      this.projectInfo = await SDK.getBaseInfo(this.id);
      // this.projectInfo.operationOpen = 1;
      // this.projectInfo.projectStatus = 4;
    },
    // 获取报名项目统计信息
    async getStatisticsInfo() {
      const SDK = this.$parent.SDK;
      this.statisticsInfo = await SDK.getStatisticsInfo(this.id);
    },
    // 获取列表信息
    async getList() {
      this.query.projectId = this.id;
      const SDK = this.$parent.SDK;
      await SDK.getRecordList(this.query)
        .then(res => {
          if (res.error) {
            this.$message.error(res.error.message);
            return;
          }
          this.tableData = res.datas;
          this.query.limit = res.paging.limit;
          this.pages = res.paging.pages;
          this.count = res.paging.count;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSearch() {
      this.query.current = 1;
      this.getProjectInfo();
      this.getStatisticsInfo();
      this.getList();
    },
    setApply() {
      this.$emit('toConfig', this.id);
    },
    // 更多
    handleMoreOpt(val) {
      switch (val) {
        case '1':
          this.urge();
          break;
        case '4':
          this.exportData();
          break;
      }
    },
    // 添加名额展示
    showDialog() {
      this.dialogVisible = true;
    },
    // 关闭
    beforeClose(done) {
      done && done();
    },
    // 查询调查列表
    async surveys(isInit) {
      if (this.siginup) {
        this.$parent.fmessage(
          await this.siginup.surveys({
            keyword: this.keyword,
            createTimeDirection: this.createTimeDirection
          }),
          async({ datas = [] }) => {
            if (isInit) {
              this.formDatasLen = datas.length;
            }
            this.formDatas = datas;
          }
        );
      }
    },
    sortChange(_, _1, order) {
      this.createTimeDirection = order;
      this.surveys();
    },
    // 查看表单统计
    async rowClick(row) {
      if (this.siginup && row) {
        this.$parent.fmessage(await this.siginup.surveyUrl(row.surveyTaskId), ({ data }) => window.open(data));
      }
    },
    // 报名表单列表
    async showFormList() {
      if (this.formDatas.length > 1) {
        this.formsVisible = true;
        this.keyword = '';
        this.createTimeDirection = '';
        this.formDatas = [];
        this.$nextTick(() => {
          const table = this.$refs.formTable.getBoundingClientRect();
          this.formHeight = table.height;
          this.surveys();
        });
      } else {
        this.rowClick(this.formDatas[0]);
      }
    },
    /**
     * 批量转正
     * 点击批量转正，如果列表中复选框未选中替补人员，提示：“请选择替补人员。”；
     * 否则提示：“转正成功。”，或“转正失败。”，转正发消息通知名额。
     */
    async batchPositive() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning(this.language().msg_please_select_person);
        return;
      } else if (this.multipleSelection.length > 50) {
        this.$message.warning(this.language().msg_50_upper_limit);
        return;
      }
      // 批量转正
      const SDK = this.$parent.SDK;
      await SDK.formalRecords({
        recordIds: this.multipleSelection.map(item => {
          return item.id;
        }),
        projectId: this.id
      }).then(res => {
        this.$message.success(this.language().msg_positivesuccess);
        this.getProjectInfo();
        this.getStatisticsInfo();
        this.getList();
      });
    },

    // 催促弹窗
    urge() {
      this.$confirm('', this.language().msg_confirm_urge, {
        confirmButtonText: this.language().btn_confirm,
        cancelButtonText: this.language().btn_cancel,
        type: 'warning'
      })
        .then(() => {
          this.urgeProject();
        })
        .catch(() => {});
    },
    // 催促报名
    async urgeProject() {
      if (
        this.projectInfo.remainPushTimes &&
        this.projectInfo.remainPushTimes > 0
      ) {
        this.loading = true;
        const SDK = this.$parent.SDK;
        await SDK.pushProject(this.id).then(res => {
          if (res.error) {
            this.$message.error(res.error.message);
            return;
          }
          this.$message.success(this.language().msg_urgeSignupaudit + res.remainCount);
          this.getProjectInfo();
          this.getStatisticsInfo();
          this.getList();
        });
        this.loading = false;
      } else {
        this.$message.error(this.language().msg_urgeSignupaudit1);
      }
    },
    // 取消弹窗
    cancelStatus(row) {
      this.$confirm(
        this.cancelMessage,
        this.language().msg_confirm_disqualified,
        {
          confirmButtonText: this.language().btn_confirm,
          cancelButtonText: this.language().btn_cancel,
          type: 'warning'
        }
      )
        .then(() => {
          this.batchCancel(row.id);
          this.handleSearch();
        })
        .catch(() => {});
    },
    // 取消资格
    async batchCancel(id) {
      const SDK = this.$parent.SDK;
      await SDK.cancelRecords({
        recordId: id,
        projectId: this.id

      }).then(res => {
        if (res.error) {
          this.$message.error(res.error.message);
          return;
        }
        this.$message.success(this.language().msg_cancel_success);
        this.getProjectInfo();
        this.getStatisticsInfo();
        this.getList();
      }).catch(() => {
        this.$message.success(this.language().msg_cancel_failed);
      });
    },

    /**
     * 导出数据
     * 按网页输出格式中的模板来导出数据
     */
    async exportData() {
      if (this.tableData.length === 0) {
        // 若无数据，则吐司提示：暂无数据；
        this.$message.error(this.language().msg_empty);
      } else {
        this.loading = true;
        // 批量转正
        const SDK = this.$parent.SDK;
        await SDK.getRecordExport({
          projectId: this.id,
          enrollType: this.query.enrollType,
          enrollStatus: this.query.enrollStatus,
          searchKey: this.query.searchKey
        }).then(res => {
          if (res.error) {
            this.$message.error(res.error.message);
            return;
          }
          this.$downloadFile();
        });
        this.loading = false;
      }
    },
    // 下载文件
    $downloadFile() {
      this.$confirm(
        this.language().msg_downloading,
        this.language().tit_viewexportfile,
        {
          confirmButtonText: this.language().btn_see,
          cancelButtonText: this.language().btn_cancel,
          type: 'success'
        }
      )
        .then(() => {
          let href = window.location.origin + '/down/#/download';
          window.open(href, '_blank');
        })
        .catch(() => {});
    },
    // 复选框选中的人
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    selectable(row, index) {
      if (row.enrollStatus === 5) {
        return true;
      }
      return false;
    },
    handleCurrentChange(val) {
      this.query.current = val;
      this.getProjectInfo();
      this.getStatisticsInfo();
      this.getList();
    },
    handleSizeChange(val) {
      this.query.limit = val;
      this.getProjectInfo();
      this.getStatisticsInfo();
      this.getList();
    },

    /**
     * 查看
     */
    async viewDetail(row) {
      if (row.id) {
        this.$emit('toDetail', row.id, this.id);
      }
    },

    change(users, groups) {
      this.tempUsers = users;
    },
    // 添加名额确定
    async addUsers() {
      if (this.$refs.selector.processing) {
        this.$message.warning(this.language().msg_doing);
        return;
      }
      const SDK = this.$parent.SDK;
      const list = this.tempUsers.map(item => {
        return item.id;
      });
      if (list.length !== 0) {
        await SDK.addRecords({
          projectId: this.id,
          userIds: list
        })
          .then(res => {
            if (res.error) {
              this.$message.error(res.error.message);
              return;
            }
            if (res.status === 2) { // 全部成功
              this.$message.success(this.language().msg_add_success);
            } else if (res.status === 0) {
              let msg = '';
              if (res.existFailCount > 0) {
                msg += res.existFailCount + this.language().msg_info1;
              }
              if (res.excludeCount > 0) {
                msg += res.excludeCount + this.language().msg_info2;
              }
              if (res.lackPointCount > 0) {
                msg += res.lackPointCount + this.language().msg_info3;
              }
              msg += this.language().msg_info4;
              this.$message.error(msg);
            } else { // 部分失败/全部
              let msg = this.language().msg_info0;
              if (res.existFailCount > 0) {
                msg += res.existFailCount + this.language().msg_info1;
              }
              if (res.excludeCount > 0) {
                msg += res.excludeCount + this.language().msg_info2;
              }
              if (res.lackPointCount > 0) {
                msg += res.lackPointCount + this.language().msg_info3;
              }
              msg += this.language().msg_info3;
              this.$message.error(msg);
            }
            this.users = [];
            this.getProjectInfo();
            this.getStatisticsInfo();
            this.getList();
          })
          .catch(error => {
            this.$message.error(this.language().msg_add_failed);
            console.log(error);
          });
      } else {
        this.$message.warning(this.language().msg_quota);
      }

      this.dialogVisible = false;
    },

    closeSelect(done) {
      done(this.$refs.selector.showTip);
    },
    closeDialog() {
      // 可以使用Drawer的默认关闭事件
      this.$refs.selectDrawer.closeDrawer();
    }
  }
};
</script>
